module.exports = __webpack_public_path__ + "img/offer.e53313e4.png";